import api from "./axios";

const BASE = "/payouts";
const BLOB = { responseType: "blob" };

export const listPayouts = (params = {}) => api.get(BASE, { params });
export const listInProgressPayouts = (params = {}) =>
  api.get(`${BASE}/in-progress`, { params });
export const listTransferredPayouts = (params = {}) =>
  api.get(`${BASE}/transferred`, { params });
export const listHoldPayouts = (params = {}) => api.get(`${BASE}/hold`, { params });

export const getPayoutKpis = (params = {}) => api.get(`${BASE}/kpis`, { params });

export const createPayout = (payload) => api.post(BASE, payload);
export const updatePayout = (id, payload) => api.put(`${BASE}/${id}`, payload);
export const deletePayout = (id) => api.delete(`${BASE}/${id}`);

export const transferPayout = (id, payload = {}) =>
  api.put(`${BASE}/${id}/transfer`, payload);
export const holdPayout = (id, holdReason) => api.put(`${BASE}/${id}/hold`, { holdReason });
export const releasePayout = (id) => api.put(`${BASE}/${id}/release`);

export const downloadPayoutTemplate = () => api.get(`${BASE}/template`, BLOB);

export const uploadPayouts = (file, { month, year }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("month", month);
  form.append("year", year);
  return api.post(`${BASE}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const exportPayouts = (params = {}) => api.get(`${BASE}/export`, { params, ...BLOB });
